import React, { useState } from "react";
import "./RAQ.css";
import { FaPaperPlane } from "react-icons/fa";
import emailjs from "@emailjs/browser";

function RequestQuote() {
  const [selectedItems, setSelectedItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);


  const services = [
    "CNC Machining",
    "3D Printing",
    "Injection Molding",
    "Sheet Metal",
    "Casting",
    "Custom Spare Parts",
    "Metal 3D Printing",
    "Vacuum Formed Enclosures",
    "CAD Modelling Software",
    "Mold Manufacturing",
    "Other"
  ];

  const toggleItem = (item) => {
    if (selectedItems.includes(item)) {
      setSelectedItems(selectedItems.filter((i) => i !== item));
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };

  // 🔹 Upload file to Cloudinary
const uploadToCloudinary = async () => {
  if (files.length === 0) return [];

  const uploadedLinks = [];

  for (let file of files) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "qxdj0o6n");

    try {
      const response = await fetch(
        "https://api.cloudinary.com/v1_1/djxtktsap/auto/upload",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (data.secure_url) {
        const downloadUrl = data.secure_url.replace(
          "/upload/",
          "/upload/fl_attachment/"
        );
        uploadedLinks.push(downloadUrl);
      }

    } catch (error) {
      console.error("Upload error:", error);
    }
  }

  return uploadedLinks;
};

const handleSubmit = async (e) => {
  e.preventDefault();

  if (selectedItems.length === 0) {
    alert("Please select at least one service.");
    return;
  }

  setLoading(true);
  const form = e.target;

  try {
    // 🔹 Upload multiple files
    const fileUrls = await uploadToCloudinary();

    const templateParams = {
      from_name: form.name.value,
      from_email: form.email.value,
      company: form.company.value || "Not Provided",
      phone: form.phone.value || "Not Provided",
      services: selectedItems.join(", "),
      message: form.message.value,
      file_link:
        fileUrls.length > 0
          ? fileUrls.join("\n")
          : "No files uploaded",
    };

    // 🔹 Send Admin Email
    await emailjs.send(
      "service_s2moltk",
      "template_3ma9e2c",
      templateParams,
      "Oko3ZS0UFXAT25mkh"
    );

    setShowModal(true);
    form.reset();
    setSelectedItems([]);
    setFiles([]);   // ✅ reset multiple files

  } catch (error) {
    console.error("Submission Error:", error);
    alert("Failed to send request. Please try again.");
  }

  setLoading(false);
};

  return (
    <div className="quote-page">
      <div className="quote-hero">
        <div className="container">
          <h1>
            Get Your <span>Custom Quote</span> Today
          </h1>
          <p className="lead">
            Fast, accurate pricing for engineering spares and custom manufacturing solutions.
            <br />
            Most quotes delivered within <strong>4–24 hours</strong>.
          </p>
        </div>
      </div>

      <div className="container">
        <div className="rq-simple-wrapper">
          <form onSubmit={handleSubmit}>

            <div className="rq-row">
              <div className="rq-field">
                <label>Full Name *</label>
                <input name="name" type="text" required />
              </div>

              <div className="rq-field">
                <label>Business Email *</label>
                <input name="email" type="email" required />
              </div>
            </div>

            <div className="rq-row">
              <div className="rq-field">
                <label>Company</label>
                <input name="company" type="text" />
              </div>

              <div className="rq-field">
                <label>Phone</label>
                <input name="phone" type="tel" />
              </div>
            </div>

            <div className="rq-field full">
              <label>Select Required Services *</label>
              <div className="service-box-container">
                {services.map((service, index) => (
                  <div
                    key={index}
                    className={`service-box ${
                      selectedItems.includes(service) ? "active" : ""
                    }`}
                    onClick={() => toggleItem(service)}
                  >
                    {service}
                  </div>
                ))}
              </div>
            </div>

            <div className="rq-field full">
              <label>Project Details *</label>
              <textarea name="message" rows="4" required />
            </div>

            <div className="rq-field full">
              <label>Upload Drawing / File</label>
              <input
  type="file"
  multiple
  onChange={(e) => {
    const selectedFiles = Array.from(e.target.files);

    // 25MB per file limit
    const validFiles = selectedFiles.filter(file => {
      if (file.size > 25 * 1024 * 1024) {
        alert(`${file.name} exceeds 25MB limit`);
        return false;
      }
      return true;
    });

    setFiles(validFiles);
  }}
/>


             {files.length > 0 && (
  <ul style={{ marginTop: "8px", fontSize: "14px" }}>
    {files.map((file, index) => (
      <li key={index}>{file.name}</li>
    ))}
  </ul>
)}

            </div>

            <button type="submit" id="rq_submit_btn" disabled={loading}>
              <FaPaperPlane />
              {loading ? "Sending..." : "Request A Quote"}
            </button>

          </form>
        </div>
      </div>

      {showModal && (
        <div className="rq-modal-overlay">
          <div className="rq-modal">
            <h3>Thank You!</h3>
            <p>We have received your request.</p>
            <p><strong>We will get back to you soon.</strong></p>
            <button onClick={() => setShowModal(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default RequestQuote;
